<div class="select-field">
  <!-- Label row with required indicator -->
  @if (label()) {
    <div class="select-field__label-row">
      <label class="select-field__label">{{ label() | translateLang }}@if (required()) {<span class="select-field__required-asterisk">*</span>}</label>
    </div>
  }

  <!-- PrimeNG Select -->
  <p-select
    [(ngModel)]="value"
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder() | translateLang"
    [fluid]="fluid()"
    [disabled]="disabled()"
    [showClear]="showClear()"
    [filter]="filter()"
    [filterPlaceholder]="filterPlaceholder() | translateLang"
    [checkmark]="checkmark()"
    [ngClass]="{ 'p-invalid': isInvalid() }"
    [attr.aria-label]="effectiveAriaLabel() | translateLang"
    (onChange)="onChange($event)"
    (onBlur)="onBlur()"
    (onFocus)="onFocus()"
    (onClear)="onClear()"
  >
    <!-- Default dropdown icon template -->
    <ng-template pTemplate="dropdownicon">
      <app-icon name="chevron-down" [size]="10" [color]="'#9F9696'"></app-icon>
    </ng-template>

    <!-- Default selected item template -->
    <ng-template let-selectedOption pTemplate="selectedItem">
      @if (selectedOption) {
        {{ selectedOption[optionLabel()] | translateLang }}
      }
    </ng-template>

    <!-- Default item template -->
    <ng-template let-option pTemplate="item">
      {{ option[optionLabel()] | translateLang }}
    </ng-template>
  </p-select>

  <!-- Error message -->
  @if (isInvalid()) {
    <div class="select-field__error-message">
      {{ errorMessage() | translateLang }}
    </div>
  }
</div>
